import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col,
  Label,
  Button,
  FormGroup,
  Input,
  Form,
  Alert,
} from 'reactstrap';

const RepairLogEntryForm = ({
  logEntry,
  onChange,
  onSave,
  saving,
  onDelete,
  errors,
  user,
}) => {
  return (
    <Container>
      <Row>
        <Col md={3} />
        <Col md={6}>
          <Form className="mb-5">
            <FormGroup>
              <Label for="id">Entry ID</Label>
              <Input
                type="text"
                name="id"
                id="id"
                value={logEntry.id}
                readOnly="true"
              />
            </FormGroup>
            <FormGroup>
              <Label for="logId">Log ID</Label>
              <Input
                type="text"
                name="logId"
                id="logId"
                value={logEntry.logId}
                readOnly="true"
              />
              {errors.logId && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.logId}
                </Alert>
              )}
            </FormGroup>
            <FormGroup>
              <Label for="hoursTaken">Time Taken</Label>
              <Input
                type="number"
                id="hoursTaken"
                name="hoursTaken"
                value={logEntry.hoursTaken}
                onChange={onChange}
              />
              {errors.hoursTaken && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.hoursTaken}
                </Alert>
              )}
            </FormGroup>
            <FormGroup>
              <Label for="location">Location</Label>
              <Input
                type="text"
                id="location"
                name="location"
                value={logEntry.location}
                onChange={onChange}
              />
            </FormGroup>
            {errors.location && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.location}
              </Alert>
            )}
            <FormGroup>
              <Label for="description">Entry</Label>
              <Input
                type="textarea"
                id="description"
                name="description"
                value={logEntry.description}
                onChange={onChange}
              />
            </FormGroup>
            {errors.description && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.description}
              </Alert>
            )}
            <FormGroup>
              <Label for="userId">Employee</Label>
              <Input
                type="text"
                name="userId"
                id="userId"
                value={user ? user.initials : 'N/A'}
                readOnly="true"
              />
            </FormGroup>
            <FormGroup>
              <Button
                color="primary"
                type="submit"
                disabled={saving}
                onClick={onSave}
                className="mr-2"
              >
                {saving ? 'Saving' : 'Save'}
              </Button>
              <Button
                color="danger"
                type="submit"
                disabled={saving}
                onClick={onDelete}
              >
                {saving ? 'Deleting' : 'Delete'}
              </Button>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

RepairLogEntryForm.propTypes = {
  logEntry: PropTypes.object,
};

export default RepairLogEntryForm;



// WEBPACK FOOTER //
// ./src/components/repair-log/RepairLogEntryForm.js